const isGtmContainerId = (containerId) => /^GTM-[A-Z0-9]+$/i.test(containerId);

const getSafeGtmContainerId = (containerId) =>
   isGtmContainerId(containerId) ? containerId : '';

const getGtmScript = (containerId) =>
   `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer','${containerId}');`;

const getGtmNoScriptSrc = (containerId) =>
   `https://www.googletagmanager.com/ns.html?id=${containerId}`;

export { getGtmNoScriptSrc, getGtmScript, getSafeGtmContainerId };
